import AISummary from './AISummary';

export default AISummary;
